export default __webpack_public_path__ + "static/media/team-pic.dff5be1b.png";